module.exports = __webpack_public_path__ + "static/media/rummyclubrsz.93b5968e.mp4";